import { UploadArea } from 'components/UploadArea'
import UploadedImageView from './SingleUploadedImageView'
import { memo, useCallback } from 'react'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { useSelector } from 'react-redux'
import { isBlobUrl } from 'utils'
import { useFrameHandlers } from '../hooks/useFrameHandlers'
import { ReferenceMediaImageType } from 'types/aiVideo'
import { IMyFilesMediaItem } from 'types/media'

const SingleRefContainer: React.FC = () => {
  const firstFrame = useSelector(aiVideoSelectors.firstFrame)
  const { url, isLoading } = firstFrame || {}
  const isImageUploading = isLoading || isBlobUrl(url)

  const { addFrameFromMediaLib, onUploadFrame, handleRemoveFrame } =
    useFrameHandlers()

  const addFirstFrameFromMediaLib = useCallback(
    (files: IMyFilesMediaItem[]) => {
      addFrameFromMediaLib(ReferenceMediaImageType.FIRST_FRAME, files)
    },
    [addFrameFromMediaLib]
  )

  const uploadFirstFrame = useCallback(
    (files: File[] | FileList) => {
      return onUploadFrame(ReferenceMediaImageType.FIRST_FRAME)(files)
    },
    [onUploadFrame]
  )

  return firstFrame ? (
    <UploadedImageView
      frameData={firstFrame}
      onUploadMedias={uploadFirstFrame}
      onAddMediaItemsFromMyFiles={addFirstFrameFromMediaLib}
      onRemoveImage={handleRemoveFrame}
    />
  ) : (
    <UploadArea
      handleFilesUpload={uploadFirstFrame}
      acceptType="AIVideoImage"
      mediaLibConfig={{
        fileType: 'image',
        maxFileImportCount: 1
      }}
      handleMediaLibFiles={addFirstFrameFromMediaLib}
      isLoading={isImageUploading}
    />
  )
}

export default memo(SingleRefContainer)
